import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ThumbsComponent } from '../../thumbs.shared.component';

@Component({
    selector: 'shared-thumb-for-order-type',
    templateUrl: './thumb-for-order-type.shared.component.html',
    styleUrls: ['./thumb-for-order-type.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThumbForOrderTypeComponent extends ThumbsComponent {
    @Input() public radius: string = '15px';
}
